export default "__VITE_ASSET__IiRzb0Wk__"